<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import { Col, Container, Row } from "sveltestrap";
  import { Button } from "sveltestrap";
</script>

<div>
  <!-- <img src="/images/common/product_banner.jpg" alt="배너 이미지" /> -->
  <img src="/images/common/comming_soon.jpg" alt="레일제어시스템 이미지" />
</div>

<style lang="scss">
</style>
